package com.appsyde.shared.modules.invite.data.source

/**
 * Résultat de l’acceptation d’invitation.
 * Permet d’afficher un message adapté (déjà acceptée, invalide, session expirée, etc.).
 */
sealed class AcceptInviteResult {
    /** Token présent ; si [alreadyUsed] = true, l'invitation était déjà acceptée mais on connecte quand même. */
    data class Success(val accessToken: String, val alreadyUsed: Boolean = false) : AcceptInviteResult()
    data object NeedLogin : AcceptInviteResult()
    data object AlreadyUsed : AcceptInviteResult()
    data object InvalidOrExpired : AcceptInviteResult()
}
